<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{ [selected && selected.id ? 'MODIFICA' : 'NUOVO','CONTRATTO'].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
      <form-wizard autofocus v-on:submit.prevent="stop" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="this.selected.azienda ? this.selected.azienda.ragione_sociale : ''" :subtitle="this.selected.responsabile ? [this.selected.responsabile.cognome,this.selected.responsabile.nome].join(' ') : ''" nextButtonText="Avanti" backButtonText="Indietro" finishButtonText="Salva" @on-complete="onSalva">
        <!-- tab 1 content -->
        <tab-content title="Dati generali" class="mb-5" icon="feather icon-list" :before-change="validateStep1">
          <form data-vv-scope="step-1">
            <vs-col class="md:w-1/2 w-full mb-base">
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <label class="vs-input--label">Modalità di pagamento</label>
                  <v-select class="w-full" placeholder="Scegli il metodo di pagamento" :options="metodi_pagamento" name="metodo_pagamento" v-model="metodo_pagamento" v-validate="'required'" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                  <span class="text-danger text-sm" v-show="errors.has('step-1.metodo_pagamento')">{{ errors.first('step-1.metodo_pagamento') }}</span>
                </vs-col>
              </vs-row>
              <vs-row class="mb-6">
                <vs-col vs-w="12">
                  <label class="vs-input--label">Data decorrenza</label>
                  <datepicker typeable  placeholder="Scegli la data di decorrenza" :language="languages['it']" :format="datepicker_format" name="data_decorrenza" v-validate="'required'" v-model="data_decorrenza"></datepicker>
                  <span class="text-danger text-sm" v-show="errors.has('step-1.data_decorrenza')">{{ errors.first('step-1.data_decorrenza') }}</span>
                </vs-col>
              </vs-row>
              <vs-row v-if="this.selected.data_emissione">
                <vs-col vs-w="12">
                  <span class="font-medium text-s leading-none">Data creazione: {{$tariffe.formatDateNew(this.selected.data_emissione)}}</span>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col class="md:w-1/2 w-full mb-base">
              <vs-row class="mb-6 mt-8">
                <vs-col vs-w="12">
                  <vs-checkbox color="warning" icon-pack="feather" icon="icon-twitter" v-model="persona_esposta">Persona Politicamente esposta</vs-checkbox>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-w="12">
                  <label class="vs-input--label">Ufficio assegnato</label>
                  <v-select class="w-full" placeholder="Ufficio" :options="codici_ufficio" v-model="codice_ufficio" name="codice_ufficio" :filterable="false" v-validate="'required'"><span slot="no-options">Nessun risultato</span></v-select>
                  <span class="text-danger text-sm" v-show="errors.has('step-1.codice_ufficio')">{{ errors.first('step-1.codice_ufficio') }}</span>
                </vs-col>
              </vs-row>
            </vs-col>

            <vs-col class="w-full">
              <vs-col>
                <div class="flex justify-between mb-3">
                    <span class="font-medium text-lg leading-none">Note</span>
                    <vs-checkbox icon-pack="feather" icon="icon-edit-2" color="success" v-model="visibilita_note">Stampa sul contratto</vs-checkbox>
                </div>
              </vs-col>
              <vs-col class="mt-2">
                <vs-textarea v-model="note" name="note" v-validate="'max:1000'" />
                <span class="text-danger text-sm" v-show="errors.has('step-1.note')">{{ errors.first('step-1.note') }}</span>
              </vs-col>
            </vs-col>
          </form>
        </tab-content>
        <!-- tab 1bis content -->
        <tab-content v-if="metodo_pagamento && metodo_pagamento['nome'] == 'Addebito in c/c'" title="Addebito" class="mb-5" icon="feather icon-dollar-sign" :before-change="validateStep1bis">
          <form data-vv-scope="step-1bis">
            <vs-row>
              <vs-col class="vx-col md:w-6/12 w-full">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="CreditCardIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Conto bancario</span>
                </div>
                <vs-divider />
                <vs-col class="mt-2">
                  <label class="vs-input--label">Iban Aziendale</label>
                  <vs-input v-model="addebito_full_iban" placeholder="Inserisci Iban per l'addebito.." class="w-full" name="addebito_full_iban" v-validate="'iban|required'" />
                  <span class="text-danger text-sm" v-show="errors.has('step-1bis.addebito_full_iban')">{{ errors.first('step-1bis.addebito_full_iban') }}</span>
                </vs-col>
                <vs-row>
                  <div class="flex items-end px-3 mt-8">
                    <span class="font-medium text-lg leading-none">Dettagli conto</span>
                  </div>
                  <vs-divider />
                  <vs-col vs-w="4" vs-lg="4" vs-sm="6" vs-xs="6">
                    <label class="vs-input--label">Paese</label>
                    <vs-input disabled v-model="addebito_iban['paese']" class="w-full" name="addebito_iban_paese" />
                  </vs-col>
                  <vs-col vs-w="4" vs-lg="4" vs-sm="6" vs-xs="6">
                    <label class="vs-input--label">Cin EU</label>
                    <vs-input disabled v-model="addebito_iban['cin_eu']" class="w-full" name="addebito_iban_cin_eu" />
                  </vs-col>
                  <vs-col vs-w="4" vs-lg="4" vs-sm="6" vs-xs="6">
                    <label class="vs-input--label">Cin IT</label>
                    <vs-input disabled v-model="addebito_iban['cin_it']" class="w-full" name="addebito_iban_cin_it" />
                  </vs-col>
                  <vs-col vs-w="3" vs-lg="3" vs-sm="6" vs-xs="6">
                    <label class="vs-input--label">ABI</label>
                    <vs-input disabled v-model="addebito_iban['abi']" class="w-full" name="addebito_iban_abi" />
                  </vs-col>
                  <vs-col vs-w="3" vs-lg="3" vs-sm="6" vs-xs="6">
                    <label class="vs-input--label">CAB</label>
                    <vs-input disabled v-model="addebito_iban['cab']" class="w-full" name="addebito_iban_cab" />
                  </vs-col>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Conto</label>
                    <vs-input disabled v-model="addebito_iban['conto']" class="w-full" name="addebito_iban_conto" />
                  </vs-col>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Banca</label>
                    <vs-input disabled v-model="addebito_iban['banca']" class="w-full" name="addebito_iban_banca" />
                  </vs-col>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Agenzia</label>
                    <vs-input disabled v-model="addebito_iban['agenzia']" class="w-full" name="addebito_iban_agenzia" />
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col class="vx-col md:w-6/12 w-full">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="HeadphonesIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Intestatario conto</span>
                </div>
                <vs-divider />
                <vs-col class="mt-2">
                  <label class="vs-input--label">Intestatario conto aziendale</label>
                  <v-select @input="setAddebito" class="w-full" placeholder="Intestatario conto" :options="['Sottoscritto','Altro']" name="tipo_titolare" />
                </vs-col>
                <vs-row>
                  <div class="flex items-end px-3 mt-8">
                    <span class="font-medium text-lg leading-none">Dati intestatario</span>
                  </div>
                  <vs-divider />
                  <vs-row>
                    <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                      <label class="vs-input--label">Nome</label>
                      <vs-input :disabled="sottoscritto" v-model="addebito_nome" class="w-full" name="addebito_nome" v-validate="'max:100|required'" />
                      <span class="text-danger">{{ errors.first('step-1bis.addebito_nome') }}</span>
                    </vs-col>
                    <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                      <label class="vs-input--label">Cognome</label>
                      <vs-input :disabled="sottoscritto" v-model="addebito_cognome" class="w-full" name="addebito_cognome" v-validate="'max:100|required'" />
                      <span class="text-danger">{{ errors.first('step-1bis.addebito_cognome') }}</span>
                    </vs-col>
                    <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                      <label class="vs-input--label">Codice Fiscale</label>
                      <vs-input :disabled="sottoscritto" v-model="addebito_codice_fiscale" class="w-full" name="addebito_codice_fiscale" v-validate="'codice_fiscale|required'" />
                      <span class="text-danger">{{ errors.first('step-1bis.addebito_codice_fiscale') }}</span>
                    </vs-col>
                    <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                      <label class="vs-input--label">Partita IVA</label>
                      <vs-input :disabled="sottoscritto" v-model="addebito_partita_iva" class="w-full" name="addebito_partita_iva" v-validate="sottoscritto ? 'partita_iva' : 'partita_iva|required'" />
                      <span class="text-danger">{{ errors.first('step-1bis.addebito_partita_iva') }}</span>
                    </vs-col>
                    <vs-col vs-w="8" vs-lg="8" vs-sm="12" vs-xs="12">
                      <label class="vs-input--label">Indirizzo</label>
                      <vs-input :disabled="sottoscritto" v-model="addebito_indirizzo" class="w-full" name="addebito_indirizzo" v-validate="'max:100|required'" />
                      <span class="text-danger">{{ errors.first('step-1bis.addebito_indirizzo') }}</span>
                    </vs-col>
                    <vs-col vs-w="4" vs-lg="4" vs-sm="4" vs-xs="4">
                      <label class="vs-input--label">CAP</label>
                      <vs-input :disabled="sottoscritto" v-model="addebito_cap" class="w-full" name="addebito_cap" v-validate="'max:100|required'" />
                      <span class="text-danger">{{ errors.first('step-1bis.addebito_cap') }}</span>
                    </vs-col>
                    <vs-col vs-w="8" vs-lg="8" vs-sm="4" vs-xs="4">
                      <label class="vs-input--label">Comune</label>
                      <vs-input :disabled="sottoscritto" v-model="addebito_comune" class="w-full" name="addebito_comune" v-validate="'max:100|required'" />
                      <span class="text-danger">{{ errors.first('step-1bis.addebito_comune') }}</span>
                    </vs-col>
                    <vs-col vs-w="4" vs-lg="4" vs-sm="4" vs-xs="4">
                      <label class="vs-input--label">Prov</label>
                      <vs-input :disabled="sottoscritto" v-model="addebito_provincia" class="w-full" name="addebito_provincia" v-validate="'max:100|required'" />
                      <span class="text-danger">{{ errors.first('step-1bis.addebito_provincia') }}</span>
                    </vs-col>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </form>
        </tab-content>
        <!-- tab 2 content -->
        <tab-content v-if="this.tab_aggiunte.includes('adesione')" title="Adesione" class="mb-5" icon="feather icon-star" :before-change="validateStep2">
          <form data-vv-scope="step-2">
            <vs-row>
              <vs-row>
                <vs-col class="vx-col md:w-6/12 w-full">
                  <vs-col class="vx-col w-full">
                    <div class="flex items-end px-3 mt-4">
                      <feather-icon svgClasses="w-6 h-6" icon="InfoIcon" class="mr-2" />
                      <span class="font-medium text-lg leading-none">Dati generali</span>
                    </div>
                    <vs-divider />
                    <vs-col class="mt-2">
                      <label class="vs-input--label">Corrispondenza</label>
                      <v-select class="w-full" placeholder="Invio corrispondenza" :options="invio_corrispondenze" name="adesione_invio_corrispondenza" v-model="adesione_invio_corrispondenza" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_invio_corrispondenza')">{{ errors.first('step-2.adesione_invio_corrispondenza') }}</span>
                    </vs-col>
                    <vs-col class="mt-4">
                      <label class="vs-input--label">Nome azienda uscente</label>
                      <vs-input v-model="adesione_alla_ditta" placeholder="Indica la Ragione sociale dell'azienda uscente" class="w-full" name="adesione_alla_ditta" />
                    </vs-col>
                  </vs-col>
                </vs-col>
                <vs-col class="vx-col md:w-6/12 w-full">
                  <vs-col class="vx-col w-full">
                    <div class="flex items-end px-3 mt-4">
                      <feather-icon svgClasses="w-6 h-6" icon="BoxIcon" class="mr-2" />
                      <span class="font-medium text-lg leading-none">Quota associativa</span>
                    </div>
                    <vs-divider />
                    <vs-col class="mt-2">
                      <label class="vs-input--label">Periodo o data di validità</label>
                      <vs-input v-model="adesione_validita" placeholder="Indica il periodo o anni (es. 2020/2021)" class="w-full" name="adesione_validita" v-validate="'required'" />
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_validita')">{{ errors.first('step-2.adesione_validita') }}</span>
                    </vs-col>
                    <vs-col class="mt-3">
                      <label class="vs-input--label">Numero ricevuta</label>
                      <vs-input class="w-full" lang="it-IT" v-model="adesione_ricevuta_num" name="adesione_ricevuta_num" placeholder="Indica il numero della ricevuta" type="number" v-validate="'numeric'"/>
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_ricevuta_num')">{{ errors.first('step-2.adesione_ricevuta_num') }}</span>
                    </vs-col>
                  </vs-col>
                </vs-col>
              </vs-row>
              <vs-row class="mt-6">
                <vs-col class="vx-col md:w-6/12 w-full">
                  <vs-col class="vx-col w-full">
                    <div class="flex items-end px-3 mt-4">
                      <feather-icon svgClasses="w-6 h-6" icon="BriefcaseIcon" class="mr-2" />
                      <span class="font-medium text-lg leading-none">Dati CCIAA</span>
                    </div>
                    <vs-divider />
                    <vs-col class="mt-2">
                      <label class="vs-input--label">Provincia di registrazione</label>
                      <v-select class="w-full" placeholder="Provincia" :options="province" name="adesione_provincia" v-model="adesione_provincia" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_provincia')">{{ errors.first('step-2.adesione_provincia') }}</span>
                    </vs-col>
                    <vs-col class="mt-3">
                      <label class="vs-input--label">Data di iscrizione</label>
                      <datepicker typeable placeholder="Scegli la data di registrazione" :language="languages['it']" :format="datepicker_format" name="adesione_data" v-model="adesione_data"></datepicker>
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_data')">{{ errors.first('step-2.adesione_data') }}</span>
                    </vs-col>
                    <vs-col class="mt-3">
                      <label class="vs-input--label">Numero registrazione</label>
                      <vs-input class="w-full" lang="it-IT" v-model="adesione_numero" name="adesione_numero" placeholder="Inserisci il numero" type="number" v-validate="'numeric'"/>
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_numero')">{{ errors.first('step-2.adesione_numero') }}</span>
                    </vs-col>
                  </vs-col>
                </vs-col>
                <vs-col class="vx-col md:w-6/12 w-full">
                  <vs-col class="vx-col w-full">
                    <div class="flex items-end px-3 mt-4">
                      <feather-icon svgClasses="w-6 h-6" icon="UserCheckIcon" class="mr-2" />
                      <span class="font-medium text-lg leading-none">Personale Azienda</span>
                    </div>
                    <vs-divider />
                    <vs-col class="mt-2">
                      <label class="vs-input--label">Numero dirigenti</label>
                      <vs-input class="w-full" lang="it-IT" v-model="adesione_numero_dirigenti" name="adesione_numero_dirigenti" placeholder="Scrivi il numero di dirigenti" type="number" v-validate="'integer'"/>
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_numero_dirigenti')">{{ errors.first('step-2.adesione_numero_dirigenti') }}</span>
                    </vs-col>
                    <vs-col class="mt-3">
                      <label class="vs-input--label">Numero di dipendenti</label>
                      <vs-input class="w-full" lang="it-IT" v-model="adesione_numero_dipendenti" name="adesione_numero_dipendenti" placeholder="Scrivi il numero dei dipendenti" type="number" v-validate="'integer'"/>
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_numero_dipendenti')">{{ errors.first('step-2.adesione_numero_dipendenti') }}</span>
                    </vs-col>
                    <vs-col class="mt-3">
                      <label class="vs-input--label">Matricola INPS</label>
                      <vs-input v-model="adesione_inps" placeholder="SCrivi la matricola INPS" class="w-full" name="adesione_inps" v-validate="'max:100'" />
                      <span class="text-danger text-sm" v-show="errors.has('step-2.adesione_inps')">{{ errors.first('step-2.adesione_inps') }}</span>
                    </vs-col>
                  </vs-col>
                </vs-col>
              </vs-row>
            </vs-row>
          </form>
        </tab-content>
        <!-- tab 3 content -->
        <tab-content v-if="this.tab_aggiunte.includes('appendice')" title="Appendice" class="mb-5" icon="feather icon-link-2" :before-change="validateStep5">
          <form data-vv-scope="step-4">
            <vs-row>
              <vs-col class="vx-col md:w-1/2 w-full">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="CalendarIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Decorrenza contratto <small>(indicazioni sul contratto precedentemente sottoscritto)</small></span>
                </div>
              </vs-col>
              <vs-divider />
              <vs-col class="vx-col w-full">
                <vs-col class="mt-2">
                  <vs-radio class="text-lg" v-model="radio_ca" vs-name="radio_ca" vs-value="false">Il presente Contratto decorre dalla data di soddisfazione della presente appendice ed ha durata limitata nell’anno solare in corso</vs-radio>
                </vs-col>
                <vs-row>
                  <vs-col class="mt-6" vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
                    <vs-radio class="text-lg" v-model="radio_ca" vs-name="radio_ca" vs-value="true">Il presente Contratto decorre dalla data</vs-radio>
                  </vs-col>
                  <vs-col class="mt-4" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <datepicker typeable :disabled="radio_ca == 'false'" placeholder="Scegli la data.." :language="languages['it']" :format="datepicker_format" name="appendice_data" v-model="appendice_data"></datepicker>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col class="w-full mt-6">
                <vs-col>
                  <div class="flex justify-between mb-3">
                      <span class="font-medium text-lg leading-none">Note da inserire solo nel contratto Appendice</span>
                  </div>
                </vs-col>
                <vs-col class="mt-2">
                  <vs-textarea v-model="appendice_note" name="note" v-validate="'max:500'" />
                </vs-col>
              </vs-col>
            </vs-row>
          </form>
        </tab-content>
        <!-- tab 4 content -->
        <tab-content v-if="this.tab_aggiunte.includes('antiriciclaggio')" title="Antiriciclaggio" class="mb-5" icon="feather icon-eye" :before-change="validateStep3">
          <form data-vv-scope="step-3">
            <vs-row>
              <vs-row vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="InfoIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Indicazioni sul titolare dell'azienda</span>
                </div>
                <vs-divider />
                <vs-col vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
                  <label class="vs-input--label">Tipo Titolare/i</label>
                  <v-select class="w-full" placeholder="Scegli il tipo di titolare..." :options="['Unico Titolare effettivo','Unico Titolare unitamente a','Non unico Titolare','Non esiste Titolare effettivo']" name="tipo_titolare" v-model="antiric_tipo_titolare" v-validate="'required'"></v-select>
                  <span class="text-danger text-sm" v-show="errors.has('step-3.tipo_titolare')">{{ errors.first('step-3.tipo_titolare') }}</span>
                </vs-col>
                <div id="err" style="color:red;">{{errSoci}}</div>
              </vs-row>
              <vs-col v-if="antiric_tipo_titolare != 'Non esiste Titolare effettivo' || antiric_tipo_titolare == null  || antiric_tipo_titolare == ''" class="md:w-6/12 w-full mt-10">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="ShieldIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Dati Titolare</span>
                </div>
                <vs-divider />
                <vs-row>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Nome</label>
                    <vs-input v-model="antiric_titolare['nome']" class="w-full" name="titolare_nome" v-validate="'required'"/>
                    <span class="text-danger">{{ errors.first('step-3.titolare_nome') }}</span>
                  </vs-col>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Cognome</label>
                    <vs-input v-model="antiric_titolare['cognome']" class="w-full" name="titolare_cognome" v-validate="'required'"/>
                    <span class="text-danger">{{ errors.first('step-3.titolare_cognome') }}</span>
                  </vs-col>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Luogo Nascita</label>
                    {{antiric_titolare.luogo_nascita}}
                    <vs-input v-model="antiric_titolare['luogo_nascita']" class="w-full" name="titolare_luogo_nascita" v-validate="'required'"/>
                    <span class="text-danger">{{ errors.first('step-3.titolare_luogo_nascita') }}</span>
                  </vs-col>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Data Nascita</label>
                    <vs-input type="date" v-model="antiric_titolare['data_nascita']" class="w-full" name="titolare_data_nascita" v-validate="'required'"/>
                    <span class="text-danger">{{ errors.first('step-3.titolare_data_nascita') }}</span>
                  </vs-col>
                  <vs-col vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Tipo documento</label>
                    <v-select class="w-full" :options="antiric_tipo_doc" name="titolare_tipo_doc" v-model="antiric_titolare['tipo_doc']" :filterable="false" v-validate="'required'"/>
                    <span class="text-danger">{{ errors.first('step-3.titolare_tipo_doc') }}</span>
                  </vs-col>
                  <vs-col vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Numero documento</label>
                    <vs-input v-model="antiric_titolare['num_doc']" class="w-full" name="titolare_num_doc" v-validate="'required'"/>
                    <span class="text-danger">{{ errors.first('step-3.titolare_num_doc') }}</span>
                  </vs-col>
                  <vs-col vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Data di scadenza</label>
                    <vs-input type="date" v-model="antiric_titolare['data_scadenza']" class="w-full" name="titolare_data_scadenza" v-validate="'required'"/>
                    <!-- <datepicker typeable :language="languages['it']" :format="datepicker_format" name="titolare_data_scadenza" v-validate="'required'" v-model="antiric_titolare['data_scadenza']"></datepicker> -->
                    <span class="text-danger">{{ errors.first('step-3.titolare_data_scadenza') }}</span>
                  </vs-col>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Autorità</label>
                    <v-select class="w-full" :options="antiric_tipo_autorit" name="titolare_autorita" v-model="antiric_titolare['autorita']" :filterable="false" v-validate="'required'"/>
                    <span class="text-danger">{{ errors.first('step-3.titolare_autorita') }}</span>
                  </vs-col>
                  <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label">Luogo</label>
                    <vs-input v-model="antiric_titolare['luogo_documento']" class="w-full" name="titolare_luogo_documento" v-validate="'required'"/>
                    <span class="text-danger">{{ errors.first('step-3.titolare_luogo_documento') }}</span>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col v-if="antiric_tipo_titolare == 'Unico Titolare unitamente a' || antiric_tipo_titolare == 'Non unico Titolare'" class="md:w-6/12 w-full mt-4">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="UsersIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Soci</span>
                  <vs-col v-if="antiric_tipo_titolare == 'Unico Titolare unitamente a' || antiric_tipo_titolare == 'Non unico Titolare'" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
                    <vs-button @click="addSocio($event)" color="success" type="line" icon-pack="feather" icon="icon-plus">Nuovo socio</vs-button>
                  </vs-col>
                </div>
                <vs-divider />
                <vs-row v-if="antiric_tipo_titolare != 'Non esiste Titolare effettivo' || antiric_tipo_titolare != 'Unico Titolare effettivo'" class="socio" :key="idx" v-for="(socio, idx) in antiric_soci">
                  <vs-collapse type="margin" class="w-full">
                   <vs-collapse-item>
                     <div slot="header">
                       <span class="font-medium text-lg leading-none">Socio: #{{idx+1}}</span>
                     </div>
                     <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Nome</label>
                       <vs-input v-model="socio['nome']" class="w-full" :name="'nome' + idx" v-validate="'required'"/>
                       <span class="text-danger">{{ errors.first('step-3.nome' + idx) }}</span>
                     </vs-col>
                     <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Cognome</label>
                       <vs-input v-model="socio['cognome']" class="w-full" :name="'cognome' + idx" v-validate="'required'"/>
                       <span class="text-danger">{{ errors.first('step-3.cognome' + idx) }}</span>
                     </vs-col>
                     <vs-col vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Luogo di nascita</label>
                       <vs-input v-model="socio['luogo_nascita']" class="w-full" :name="'luogo_nascita' + idx" v-validate="'required'" />
                       <span class="text-danger">{{ errors.first('step-3.luogo_nascita' + idx) }}</span>
                     </vs-col>
                     <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Data Nascita</label>
                       <vs-input type="date" v-model="socio['data_nascita']" class="w-full" :name="'data_nascita' + idx" v-validate="'required'"/>
                       <span class="text-danger">{{ errors.first('step-3.data_nascita' + idx) }}</span>
                     </vs-col>
                     <vs-col vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Tipo documento</label>
                       <v-select class="w-full" :options="antiric_tipo_doc" :name="'tipo_doc' + idx" v-model="socio['tipo_doc']" :filterable="false" v-validate="'required'" />
                       <span class="text-danger">{{ errors.first('step-3.tipo_doc' + idx) }}</span>
                     </vs-col>
                     <vs-col vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Numero documento</label>
                       <vs-input v-model="socio['num_doc']" class="w-full" :name="'num_doc' + idx" v-validate="'required'" />
                       <span class="text-danger">{{ errors.first('step-3.num_doc' + idx) }}</span>
                     </vs-col>
                     <vs-col vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Data scadenza</label>
                       <vs-input type="date" v-model="socio['data_scadenza']" class="w-full" :name="'data_scadenza' + idx" v-validate="'required'"/>
                       <!-- <datepicker typeable :language="languages['it']" :format="datepicker_format" :name="'data_scadenza' + idx" v-validate="'required'" v-model="socio['data_scadenza']"></datepicker> -->
                       <span class="text-danger">{{ errors.first('step-3.data_scadenza' + idx) }}</span>
                     </vs-col>
                     <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Autorità</label>
                       <v-select class="w-full" :options="antiric_tipo_autorit" :name="'autorita' + idx" v-model="socio['autorita']" :filterable="false" v-validate="'required'"/>
                       <span class="text-danger">{{ errors.first('step-3.autorita' + idx) }}</span>
                     </vs-col>
                     <vs-col vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
                       <label class="vs-input--label">Luogo</label>
                       <vs-input v-model="socio['luogo_documento']" class="w-full" :name="'luogo_documento' + idx" v-validate="'required'"/>
                       <span class="text-danger">{{ errors.first('step-3.luogo_documento' + idx) }}</span>
                     </vs-col>
                     <vs-row class="mt-collapse" vs-type="flex" vs-justify="space-around">
                       <vs-button  @click="removeSocio(idx, $event)" icon-pack="feather" icon="icon-trash" color="danger" type="line" align="right">Elimina</vs-button>
                    </vs-row>
                   </vs-collapse-item>
                  </vs-collapse>
                </vs-row>
              </vs-col>
            </vs-row>
          </form>
        </tab-content>
        <!-- tab 5 content -->
        <tab-content v-if="this.tab_aggiunte.includes('privacy')" title="Privacy" class="mb-5" icon="feather icon-unlock" :before-change="validateStep4">
          <form data-vv-scope="step-4">
            <vs-col class="mb-12">
            <!-- <vs-row v-if="!this.selected.azienda && !this.selected.azienda.privacy_data" vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="left" vs-w="12">
                <h4 class="text-danger">Privacy NON firmata dall'Azienda</h4>
              </vs-col>
            </vs-row> -->
            <vs-row class="vx-row mt-4">
              <vs-col class="vx-col md:w-1/2 w-full">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="ShieldIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Consenso Trattamento dei Dati</span>
                </div>
              </vs-col>
              <vs-col v-if="this.selected.azienda && this.selected.azienda.privacy_data" class="flex md:w-1/2 w-full" vs-justify="flex-end" vs-align="center">
                <div class="flex items-end px-3 mt-6">
                  <span class="font-medium leading-none"><small>{{['Data ultima modifica: '].join(' ')}}</small>{{$tariffe.formatDateNew(this.selected.azienda.privacy_data)}}</span>
                </div>
              </vs-col>
              <vs-divider />
            </vs-row>
            <vs-row class="mt-5">
              <ul class="demo-alignment">
                <li><vs-checkbox icon-pack="feather" icon="icon-thumbs-up" color="success" v-model="privacy_b1">Autorizzo al trattamento dei dati personali</vs-checkbox></li>
                <li v-if="err_trattamento_dati" class="text-danger">{{err_trattamento_dati}}</li>
              </ul>
            </vs-row>
            <vs-row class="vx-row mt-12">
              <vs-col class="vx-col md:w-1/2 w-full">
                <div class="flex items-end px-3 mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="Share2Icon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Consenso invio delle nostre Comunicazioni:</span>
                </div>
              </vs-col>
              <vs-divider />
            </vs-row>
            <vs-row class="mt-5">
              <ul class="demo-alignment">
                <li><vs-checkbox icon-pack="feather" icon="icon-map" color="success" v-model="privacy_b2">Associative sul Territorio e sulle Federazioni</vs-checkbox></li>
                <li><vs-checkbox icon-pack="feather" icon="icon-paperclip" color="success" v-model="privacy_b3">Relative ai nostri Servizi</vs-checkbox></li>
                <li><vs-checkbox icon-pack="feather" icon="icon-shopping-cart" color="success" v-model="privacy_b4">Commerciali su Convenzioni e Promozioni</vs-checkbox></li>
                <li><vs-checkbox icon-pack="feather" icon="icon-users" color="success" v-model="privacy_b5">Trattamento Titolare Effettivo servizi</vs-checkbox></li>
              </ul>
            </vs-row>
          </vs-col>
          </form>
        </tab-content>
        <!-- tab 6 content -->
        <tab-content v-if="this.tab_aggiunte.includes('dettagli')" title="Dettagli" class="mb-5" icon="feather icon-check-square">
          <form data-vv-scope="step-5">
            <vs-row class="mb-12">
              <vs-col class="vx-col md:w-1/2 w-full">
                <div class="flex items-end mt-4">
                  <feather-icon svgClasses="w-6 h-6" icon="ShieldIcon" class="mr-2"/>
                  <span class="font-medium text-lg leading-none">Elenco modelli contratti creati, seleziona quali vuoi stampare:</span>
                </div>
              </vs-col>
              <vs-divider />
              <vs-col class="vx-col w-full">
                <vs-row class="mt-5">
                  <ul class="demo-alignment" :key="idx" v-for="(modello, idx) in lista_templates">
                    <li><vs-checkbox icon-pack="feather" icon="icon-thumbs-up" color="success" v-model="modello['attivo']" :name="'modello_' + idx" >{{modello.template_stampa ? modello.template_stampa.descrizione : modello.nome}}</vs-checkbox></li>
                  </ul>
                </vs-row>
              </vs-col>
            </vs-row>
          </form>
        </tab-content>
      </form-wizard>
    </div>
  </vs-col>
</vs-row>
</template>

<script>
import FormWizard from '@/components/vue-form-wizard/FormWizard.vue'
import TabContent from '@/components/vue-form-wizard/TabContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Vue from 'vue';
// For custom error message
import { Validator } from 'vee-validate';

// axios
import axios from 'axios'

// vue-select
import vSelect from 'vue-select'
// datepicker + languages
import Datepicker from '@sum.cumo/vue-datepicker';
import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'
import * as lang from 'vuejs-datepicker/src/locale';


const dict = {
  messages:{
    required: (field) => 'Campo obbligatorio',
  },
  custom: {
    data_decorrenza: {
      required: 'Data emissione è un campo obbligatorio'
    },
    metodo_pagamento: {
      required: 'Metodo pagamento è un campo obbligatorio'
    },
    codice_ufficio: {
      required: 'Ufficio è un campo obbligatorio'
    },
    note: {
      max: 'Massimo 1000 caratteri'
    },
    tipo_titolare: {
      required: 'Campo obbligatorio'
    },
    titolare_nome: {
      required: 'Campo obbligatorio'
    },
    titolare_cognome: {
      required: 'Campo obbligatorio'
    },
    titolare_tipo_doc: {
      required: 'Campo obbligatorio'
    },
    titolare_num_doc: {
      required: 'Campo obbligatorio'
    },
    titolare_autorita: {
      required: 'Campo obbligatorio'
    },
    titolare_luogo_nascita: {
      required: 'Campo obbligatorio'
    },
    titolare_data_nascita: {
      required: 'Campo obbligatorio'
    },
    titolare_data_scadenza: {
      required: 'Campo obbligatorio'
    },

    adesione_invio_corrispondenza: {
      required: 'Invio corrispondenza è un campo obbligatorio'
    },
    adesione_validita: {
      required: 'Validità è un campo obbligatorio'
    },
    adesione_ricevuta_num: {
      required: 'Numero ricevuta è un campo obbligatorio',
      numeric: 'Inserire un numero'
    },
    adesione_provincia: {
      required: 'Provincia è un campo obbligatorio'
    },
    adesione_data: {
      required: 'Data iscrizione è un campo obbligatorio'
    },
    adesione_numero: {
      required: 'Numero adesione è un campo obbligatorio',
      numeric: 'Inserire un numero'
    },
    adesione_numero_dirigenti: {
      required: 'Numero dirigenti è un campo obbligatorio',
      integer: 'Inserire un numero intero'
    },
    adesione_numero_dipendenti: {
      required: 'Numero dipendenti è un campo obbligatorio',
      integer: 'Inserire un numero intero'
    },
    adesione_inps: {
      required: 'Matricola INPS è un campo obbligatorio',
      max: 'Massimo 100 caratteri'
    },
    addebito_full_iban: {
      required: 'Iban è un campo obbligatorio',
      iban: 'Iban non valido',
    },
    addebito_indirizzo: {
      required: 'Campo obbligatorio',
      max: 'Massimo 500 caratteri'
    },
    addebito_partita_iva: {
      required: 'Campo obbligatorio',
      partita_iva: 'Inserire una partita iva valida'
    },
    addebito_codice_fiscale: {
      required: 'Campo obbligatorio',
      codice_fiscale: 'Inserire un codice fiscale valido'
    },
    addebito_cognome: {
      max: 'Massimo 100 caratteri',
      required: 'Campo obbligatorio',
    },
    addebito_nome: {
      required: 'Campo obbligatorio',
      max: 'Massimo 100 caratteri'
    },
    addebito_cap: {
      required: 'Campo obbligatorio',
      max: 'Massimo 100 caratteri'
    },
    addebito_comune: {
      required: 'Campo obbligatorio',
      max: 'Massimo 100 caratteri'
    },
    addebito_provincia: {
      required: 'Campo obbligatorio',
      max: 'Massimo 100 caratteri'
    },
  }
};

// register custom messages
Validator.localize('it', dict);

  var countries = {};
  countries["AL"] = {country_name: "Albania", length: 28};
  countries["AD"] = {country_name: "Andorra", length: 24};
  countries["AT"] = {country_name: "Austria", length: 20};
  countries["AZ"] = {country_name: "Azerbaijan", length: 28};
  countries["BH"] = {country_name: "Bahrain", length: 22};
  countries["BY"] = {country_name: "Belarus", length: 28};
  countries["BE"] = {country_name: "Belgium", length: 16};
  countries["BA"] = {country_name: "Bosnia and Herzegovina", length: 20};
  countries["BR"] = {country_name: "Brazil", length: 29};
  countries["BG"] = {country_name: "Bulgaria", length: 22};
  countries["CR"] = {country_name: "Costa Rica", length: 22};
  countries["HR"] = {country_name: "Croatia", length: 21};
  countries["CY"] = {country_name: "Cyprus", length: 28};
  countries["CZ"] = {country_name: "Czech Republic", length: 24};
  countries["DK"] = {country_name: "Denmark", length: 18};
  countries["DO"] = {country_name: "Dominican Republic", length: 28};
  countries["SV"] = {country_name: "El Salvador", length: 28};
  countries["EE"] = {country_name: "Estonia", length: 20};
  countries["FO"] = {country_name: "Faroe Islands", length: 18};
  countries["FI"] = {country_name: "Finland", length: 18};
  countries["FR"] = {country_name: "France", length: 27};
  countries["GE"] = {country_name: "Georgia", length: 22};
  countries["DE"] = {country_name: "Germany", length: 22};
  countries["GI"] = {country_name: "Gibraltar", length: 23};
  countries["GR"] = {country_name: "Greece", length: 27};
  countries["GL"] = {country_name: "Greenland", length: 18};
  countries["GT"] = {country_name: "Guatemala", length: 28};
  countries["VA"] = {country_name: "Holy See (the)", length: 22};
  countries["HU"] = {country_name: "Hungary", length: 28};
  countries["IS"] = {country_name: "Iceland", length: 26};
  countries["IQ"] = {country_name: "Iraq", length: 23};
  countries["IE"] = {country_name: "Ireland", length: 22};
  countries["IL"] = {country_name: "Israel", length: 23};
  countries["IT"] = {country_name: "Italy", length: 27};
  countries["JO"] = {country_name: "Jordan", length: 30};
  countries["KZ"] = {country_name: "Kazakhstan", length: 20};
  countries["XK"] = {country_name: "Kosovo", length: 20};
  countries["KW"] = {country_name: "Kuwait", length: 30};
  countries["LV"] = {country_name: "Latvia", length: 21};
  countries["LB"] = {country_name: "Lebanon", length: 28};
  countries["LI"] = {country_name: "Liechtenstein", length: 21};
  countries["LT"] = {country_name: "Lithuania", length: 20};
  countries["LU"] = {country_name: "Luxembourg", length: 20};
  countries["MT"] = {country_name: "Malta", length: 31};
  countries["MR"] = {country_name: "Mauritania", length: 27};
  countries["MU"] = {country_name: "Mauritius", length: 30};
  countries["MD"] = {country_name: "Moldova", length: 24};
  countries["MC"] = {country_name: "Monaco", length: 27};
  countries["ME"] = {country_name: "Montenegro", length: 22};
  countries["NL"] = {country_name: "Netherlands", length: 18};
  countries["MK"] = {country_name: "North Macedonia", length: 19};
  countries["NO"] = {country_name: "Norway", length: 15};
  countries["PK"] = {country_name: "Pakistan", length: 24};
  countries["PS"] = {country_name: "Palestine", length: 29};
  countries["PL"] = {country_name: "Poland", length: 28};
  countries["PT"] = {country_name: "Portugal", length: 25};
  countries["QA"] = {country_name: "Qatar", length: 29};
  countries["RO"] = {country_name: "Romania", length: 24};
  countries["LC"] = {country_name: "Saint Lucia", length: 32};
  countries["SM"] = {country_name: "San Marino", length: 27};
  countries["ST"] = {country_name: "Sao Tome and Principe", length: 25};
  countries["SA"] = {country_name: "Saudi Arabia", length: 24};
  countries["RS"] = {country_name: "Serbia", length: 22};
  countries["SC"] = {country_name: "Seychelles", length: 31};
  countries["SK"] = {country_name: "Slovak Republic", length: 24};
  countries["SI"] = {country_name: "Slovenia", length: 19};
  countries["ES"] = {country_name: "Spain", length: 24};
  countries["SE"] = {country_name: "Sweden", length: 24};
  countries["CH"] = {country_name: "Switzerland", length: 21};
  countries["TL"] = {country_name: "Timor-Leste", length: 23};
  countries["TN"] = {country_name: "Tunisia", length: 24};
  countries["TR"] = {country_name: "Turkey", length: 26};
  countries["UA"] = {country_name: "Ukraine", length: 29};
  countries["AE"] = {country_name: "United Arab Emirates", length: 23};
  countries["GB"] = {country_name: "United Kingdom", length: 22};
  countries["VG"] = {country_name: "Virgin Islands, length: British", length: 24};

function isIban(iban) {
  var IBAN = require('iban');
  return IBAN.isValid(iban)
}

Validator.extend('iban', isIban);

function isCF(cf)
{
	cf = cf.toUpperCase();
	if( cf == '' ) { return true }
  if( !isNaN(cf.charAt(0)) ) { return isPIVA(cf) }
	if( ! /^[0-9A-Z]{16}$/.test(cf) ) { return false }
	var map = [1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17,
		19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23];
	var s = 0;
	for(var i = 0; i < 15; i++) {
		var c = cf.charCodeAt(i);
		if( c < 65 ) {
			c = c - 48;
    } else {
			c = c - 55;
    }
		if( i % 2 == 0 ) {
			s += map[c];
    }	else {
			s += c < 10? c : c - 10;
    }
	}
	var atteso = String.fromCharCode(65 + s % 26);
	if( atteso != cf.charAt(15) ) {
		return false
  }
	return true
}

Validator.extend('codice_fiscale', isCF);

function isPIVA(piva)
{
	piva = piva.toUpperCase();
	if( piva == '' ) { return true }

	if( ! /^[0-9]{11}$/.test(piva) ) {
		return false
  }
	var s = 0;
	for( i = 0; i <= 9; i += 2 ) {
		s += piva.charCodeAt(i) - '0'.charCodeAt(0);
  }
	for(var i = 1; i <= 9; i += 2 ) {
		var c = 2*( piva.charCodeAt(i) - '0'.charCodeAt(0) );
		if( c > 9 )  c = c - 9;
		s += c;
	}
	var atteso = ( 10 - s%10 )%10;
	if( atteso != piva.charCodeAt(10) - '0'.charCodeAt(0) ) {
		return false
  }
	return true
}

Validator.extend('partita_iva', isPIVA);

export default {
  data() {
    return {
      datepicker_format: "d.MM.yyyy",
      languages: lang,

      lista_templates: [],
      tab_aggiunte: [],

      banche: [],

      stati: [],
      stato: null,
      codici_ufficio: [],
      codice_ufficio: null,
      province: [],
      metodi_pagamento: [],
      metodo_pagamento: null,

      sottoscritto: false,
      addebito_full_iban: "",
      addebito_iban: {},
      addebito_indirizzo: "",
      addebito_partita_iva: "",
      addebito_codice_fiscale: "",
      addebito_cognome: "",
      addebito_nome: "",
      addebito_cap: "",
      addebito_comune: "",
      addebito_provincia: "",

      invio_corrispondenze: ['Domicilio fiscale','Sede commerciale','Altro'],
      adesione_invio_corrispondenza: "",
      adesione_validita: "",
      adesione_ricevuta_num: null,
      adesione_provincia: "",
      adesione_data: "",
      adesione_numero: null,
      adesione_numero_dirigenti: null,
      adesione_numero_dipendenti: null,
      adesione_inps: "",
      adesione_alla_ditta: "",

      errSoci: '',
      antiric_tipo_doc: ['Carta d’identità', 'Passaporto', 'Patente'],
      antiric_tipo_autorit: ['Comune', 'Questura', 'Prefettura', 'Motorizzazione'],
      antiric_titolare: {},
      antiric_soci: [],
      antiric_firma: null,
      antiric_tipo_titolare: "Unico Titolare effettivo",

      privacy_b1: null,
      privacy_b2: null,
      privacy_b3: null,
      privacy_b4: null,
      privacy_b5: null,
      privacy_data: "",

      radio_ca: "false",
      appendice_data: "",
      appendice_note: "",


      note_preventivo: "",
      visibilita_note: false,
      note: "",

      id: null,
      persona_esposta: null,
      data_emissione: "",
      data_decorrenza: "",
      id_preventivo: null,
      id_creatore: null,
      id_responsabile: null,

      err_trattamento_dati: "",
    }
  },
  props: {
    selected: Object,
  },
  methods: {
    getStati() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/preventivo/elenca_stati',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.stati = response.data.map(e => {
                                  e['label'] = `${e['stato']}`
                                  return e
                                })
        if (!this.id) { this.stato = this.stati.find(e => e.label == "Aperto") }
        else { this.stato = this.stati.find(e => this.selected && e.id == this.selected.stato.id) }
              })
      .catch(e => console.log(e))
    },
    getMetodiPagamento() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/contratto/trova_metodi_pagamento',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.metodi_pagamento = response.data.map(e => {
                                  e['label'] = `${e['nome']}`
                                  return e
                                })
        if (this.selected && this.selected.metodo_pagamento) {
          this.metodo_pagamento = this.metodi_pagamento.find(e => e.id == this.selected.metodo_pagamento.id)
          this.metodo_pagamento['label'] = this.metodo_pagamento.nome
        }
      })
      .catch(e => console.log(e))
    },
    getUffici() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/azienda/get_uffici',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.codici_ufficio = response.data.map(e => {
                                  e['label'] = `${e['descrizione']} ( ${e['codice']} )`
                                  return e
                                })
        if (this.selected && this.selected.codice_ufficio) {
          // console.log('qui!!!!',this.selected.codice_ufficio, this.codici_ufficio);
          this.codice_ufficio = this.codici_ufficio.find(e => e.codice == this.selected.codice_ufficio)
        }
                              })
      .catch(e => console.log(e))
    },
    getBanche() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/get_banche', {id_crm: this.selected.azienda.id_crm},
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.banche = response.data
        if (response.data.length) {
          if (!this.addebito_full_iban) {
            this.addebito_iban = {}
            this.addebito_iban['paese'] = response.data[0].codice_paese
            this.addebito_iban['cin_eu'] = response.data[0].cin_e
            this.addebito_iban['cin_it'] = response.data[0].cin
            this.addebito_iban['abi'] = response.data[0].abi
            this.addebito_iban['cab'] = response.data[0].cab
            this.addebito_iban['conto'] = response.data[0].cc
            this.addebito_iban['banca'] = response.data[0].abi_sigla
            this.addebito_iban['agenzia'] = response.data[0].abi_ds
            let checkthis = [response.data[0].codice_paese,response.data[0].cin_e,response.data[0].cin,response.data[0].abi,response.data[0].cab,response.data[0].cc].join('')
            var IBAN = require('iban');
            if (IBAN.isValid(checkthis)) {
              this.addebito_full_iban = checkthis
            }
          }
        }
      }).catch(e => console.log(e))
    },
    getEstremiBanca() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/get_banca_details', {"abi":this.addebito_iban.abi,"cab":this.addebito_iban.cab},
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        if (response.data && response.data['abi'] && response.data['cab']) {
          this.addebito_iban = {
            "paese": this.addebito_full_iban.substr(0, 2),
            "cin_eu": this.addebito_full_iban.substr(2, 2),
            "cin_it": this.addebito_full_iban.substr(4, 1),
            "abi": response.data['abi']['cdabi'],
            "cab": response.data['cab']['cdcab'],
            "conto": this.addebito_full_iban.substr(15),
            "banca": response.data['abi']['abidsbanca'],
            "agenzia": response.data['cab']['cabsportello']
          }
        }
      }).catch(e => console.log(e))
    },
    getProvince() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/contratto/trova_province',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
        this.province = response.data.map(e => {
                                  e['label'] = `${e['provincia']}`
                                  return e
                                })
        if (this.selected && this.selected.provincia) { this.provincia = this.province.find(e => e.label == this.selected.provincia) }
      })
      .catch(e => console.log(e))
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            resolve(true)

          } else {
            reject("correct all values");
          }
        })
      })
    },
    validateStep1bis() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1bis').then(result => {
          if (result) {
            resolve(true)

          } else {
            reject("correct all values");
          }
        })
      })
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-2').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },
    validateStep3() {
      // console.log(this.antiric_titolare,this.antiric_soci)
      if (this.antiric_tipo_titolare != 'Unico Titolare effettivo' && this.antiric_tipo_titolare != 'Non esiste Titolare effettivo' && !this.antiric_soci.length) {
        this.errSoci = 'Creare Soci'
        return false
      }
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-3').then(result => {
          if (result) {
            this.errSoci = ''
            resolve(true)
          } else {
            this.errSoci = ''
            reject("correct all values");
          }
        })
      })
    },
    validateStep4() {
      if (!this.privacy_b1) {
        this.err_trattamento_dati = 'Necessario trattamento dati'
        return false
      }
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-4').then(result => {
          if (result) {
            if (!this.lista_templates.find( t => t.nuovo_nome == 'nomina_resp_esterno.docx')
                && this.privacy_b5) this.lista_templates.push({ nome: 'Nomina responsabile esterno',
                                                                nuovo_nome: 'nomina_resp_esterno.docx',
                                                                id: null,
                                                                posizione: 8,
                                                                attivo: true })
          if (!this.privacy_b5 && this.lista_templates.find( t => t.nuovo_nome == 'nomina_resp_esterno.docx')) {
            let idx = this.lista_templates.map( el => { return el.nuovo_nome }).indexOf('nomina_resp_esterno.docx')
            if (idx > -1) this.lista_templates.splice(idx,1)
          }
          if (!this.lista_templates.find( t => t.nuovo_nome == 'modulo_rid.docx')
              && this.metodo_pagamento['nome'] == 'Addebito in c/c') this.lista_templates.push({ nome: 'Modulo RID',
                                                                                                nuovo_nome: 'modulo_rid.docx',
                                                                                                id: null,
                                                                                                posizione: 3,
                                                                                                attivo: true })
        if (this.metodo_pagamento['nome'] != 'Addebito in c/c' && this.lista_templates.find( t => t.nuovo_nome == 'modulo_rid.docx')) {
          let idx = this.lista_templates.map( el => { return el.nuovo_nome }).indexOf('modulo_rid.docx')
          if (idx > -1) this.lista_templates.splice(idx,1)
        }
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },
    validateStep5() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-5').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },
    onSalva() {
      let url = this.id ? process.env.VUE_APP_BACKEND_API+'/contratto/modifica' : process.env.VUE_APP_BACKEND_API+'/contratto/crea'
      if (this.metodo_pagamento.nome != 'Addebito in c/c') {
        this.addebito_full_iban = ""
        this.addebito_iban = {}
        this.addebito_codice_fiscale = ""
        this.addebito_partita_iva = ""
        this.addebito_cognome = ""
        this.addebito_nome = ""
        this.addebito_indirizzo = ""
        this.addebito_cap = null
        this.addebito_provincia = ""
      }
      let obj = this.buildSaveObject()
      for (let [key, value] of Object.entries(obj)) {
        if (typeof value === 'string' || value instanceof String) {
          var patt1 = /[^0-9]/;
          if ( value.charAt(0).match(patt1) && key != 'addebito_codice_fiscale' ) {
            obj[key] = value.charAt(0).toUpperCase() + value.slice(1)
          }
        }
      }
      if (this.id) {
        obj['id'] = this.id
        delete obj.id_preventivo
      // } else {
      //   // Se Nuovo contratto Cerco stato Contratto (ordine = 6) e lo imposto sul preventivo
      //   axios.post(process.env.VUE_APP_BACKEND_API+'/preventivo/avanza_stato', {id: this.selected.id_preventivo, id_stato: this.stati.find(e => e.ordine == 6 ).id},{
      //     headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
      //     withCredentials: true,
      //   })
      }
      // console.log('contratto',obj);
      axios.post(url, obj,{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      })
      .then(response => {
        if (this.id) {
          //set "revisionato" if modifica
          axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/avanza_stato', {id: this.id, id_stato: this.stati.find(e => e.ordine == 3 ).id},{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
        }
        if (this.selected.azienda && (this.selected.azienda.privacy_b2 != this.privacy_b2 || this.selected.azienda.privacy_b3 != this.privacy_b3 || this.selected.azienda.privacy_b4 != this.privacy_b4 || this.selected.azienda.privacy_b5 != this.privacy_b5)) {
          axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/modifica', {
                                                          id: this.selected.azienda.id,
                                                          privacy_b2: this.privacy_b2,
                                                          privacy_b3: this.privacy_b3,
                                                          privacy_b4: this.privacy_b4,
                                                          privacy_b5: this.privacy_b5},{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
        }
        if (!this.id) {
          // Se Nuovo contratto Cerco stato Contratto (ordine = 6) e lo imposto sul preventivo
          axios.post(process.env.VUE_APP_BACKEND_API+'/preventivo/avanza_stato', {id: this.selected.id_preventivo, id_stato: this.stati.find(e => e.ordine == 6 ).id},{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          this.associaPreventivo(response.data.id)
        }
        if (this.tab_aggiunte.includes('antiriciclaggio')) {
          this.$emit('contratto-creato', 'Firma', response.data.id, response.data.antiric_firma)
        } else {
          this.$emit('contratto-creato', 'OK')
        }
      })
    },
    associaPreventivo(idcontr) {
      axios.post(process.env.VUE_APP_BACKEND_API+'/preventivo/associa_contratto', {id:this.selected.id_preventivo,id_contratto:idcontr},{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      })
      .then(response => {
        // console.log(response.data);
        this.$emit('contratto-creato', 'OK')
      })
    },
    buildSaveObject() {
      let ls_modelli = this.lista_templates.map( m => ({ id: m.template_stampa ? m.template_stampa.id : m.id,
                                                        nome: m.template_stampa ? m.template_stampa.nome : m.nome,
                                                        nuovo_nome: m.template_stampa ? m.template_stampa.nuovo_nome : m.nuovo_nome,
                                                        posizione: m.template_stampa ? m.template_stampa.posizione : m.posizione,
                                                        attivo: m.attivo ? true : false }))
      let obj = {
        //generali
        data_decorrenza: this.data_decorrenza,
        codice_ufficio: this.codice_ufficio ? +this.codice_ufficio.codice : null,
        id_metodo_pagamento: this.metodo_pagamento.id,
        persona_esposta: this.persona_esposta ? true : false,
        note: this.note == "" ? null : this.note,
        visibilita_note: this.visibilita_note ? true : false,
        //dettagli
        templates: ls_modelli,

        appendice_data: this.radio_ca == 'true' ? this.appendice_data : null,
        appendice_note: this.appendice_note ? this.appendice_note : null,
      }
      if (!this.id) {
        obj['id_preventivo'] = this.selected.id_preventivo
        obj['id_responsabile'] = this.selected.id_responsabile
        obj['id_stato'] = this.stato.id
      } else if (this.stato.ordine == 1 || this.stato.ordine == 2) {
        this.stato = this.stati.find(e => e.ordine == 3 ) // ordine = 3 Revisionato
        obj['id_stato'] = this.stato.id
      }
      if (this.metodo_pagamento.nome == 'Addebito in c/c') {
        obj['addebito_iban'] = this.addebito_full_iban || ""
        obj['addebito_indirizzo'] = this.addebito_indirizzo == "" ? null : this.addebito_indirizzo
        obj['addebito_partita_iva'] = this.addebito_partita_iva == "" ? null : this.addebito_partita_iva
        obj['addebito_codice_fiscale'] = this.addebito_codice_fiscale == "" ? null : this.addebito_codice_fiscale.toUpperCase()
        obj['addebito_cognome'] = this.addebito_cognome == "" ? null : this.addebito_cognome
        obj['addebito_nome'] = this.addebito_nome == "" ? null : this.addebito_nome
        obj['addebito_cap'] = this.addebito_cap == "" ? null : this.addebito_cap
        obj['addebito_comune'] = this.addebito_comune == "" ? null : this.addebito_comune
        obj['addebito_provincia'] = this.addebito_provincia == "" ? null : this.addebito_provincia
      }
      if(this.tab_aggiunte.includes('adesione')) {
        obj['adesione_invio_corrispondenza'] = this.adesione_invio_corrispondenza
        obj['adesione_validita'] = this.adesione_validita
        obj['adesione_ricevuta_num'] = +this.adesione_ricevuta_num
        obj['adesione_provincia'] = this.adesione_provincia.provincia
        obj['adesione_data'] = this.adesione_data ? this.adesione_data.toISOString() : null
        obj['adesione_numero'] = +this.adesione_numero
        obj['adesione_numero_dirigenti'] = +this.adesione_numero_dirigenti
        obj['adesione_numero_dipendenti'] = +this.adesione_numero_dipendenti
        obj['adesione_inps'] = this.adesione_inps
        obj['adesione_alla_ditta'] = this.adesione_alla_ditta
      }
      if(this.tab_aggiunte.includes('antiriciclaggio')) {
      // obj['antiric_firma'] = this.antiric_firma,
        obj['antiric_tipo_titolare'] = this.antiric_tipo_titolare
        // obj['antiric_titolare'] = this.antiric_titolare
        if(this.antiric_tipo_titolare != 'Non esiste Titolare effettivo') {
          if(this.antiric_tipo_titolare != 'Unico Titolare effettivo') {
            this.antiric_soci.push(this.antiric_titolare)
            obj['antiric_soci'] = this.antiric_soci
          } else {
            obj['antiric_soci'] = [this.antiric_titolare]
          }
        } else {
          obj['antiric_soci'] = []
        }
      }
      return obj
    },
    stop(ev) {
      // console.log(ev)
      ev.stopPropagation()
    },
    addSocio(ev) {
      ev.stopPropagation()
      this.antiric_soci.push({tipo_doc: "", num_doc: "", data_scadenza: "", luogo_nascita: "", autorita: ""})
    },
    removeSocio(idx, ev) {
      ev.stopPropagation()
      this.antiric_soci.splice(idx, 1)
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
    setAddebito(val) {
      if (val == 'Sottoscritto' && this.selected.azienda) {
        let str = ''
        this.sottoscritto = true
        if (this.selected.azienda.tipo_azienda == 'DITTA IND.') {
          this.addebito_nome = this.selected.azienda.ind_nome
          this.addebito_cognome = this.selected.azienda.ind_cognome
          this.addebito_codice_fiscale = this.selected.azienda.codice_fiscale
        } else {
          let check = (this.selected.azienda.contatti && this.selected.azienda.contatti.length)
          this.addebito_nome = check ? this.selected.azienda.contatti.find(c => c.id_ruolo == 93 || c.id_ruolo == 1).contatto.nome : ''
          this.addebito_cognome = check ? this.selected.azienda.contatti.find(c => c.id_ruolo == 93 || c.id_ruolo == 1).contatto.cognome : ''
          this.addebito_codice_fiscale = check ? this.selected.azienda.contatti.find(c => c.id_ruolo == 93 || c.id_ruolo == 1).contatto.codice_fiscale : ''
        }
        this.addebito_partita_iva = this.selected.azienda.partita_iva ? this.selected.azienda.partita_iva : ''
        this.addebito_indirizzo = [this.selected.azienda.indirizzo_tipo_via_dl,this.selected.azienda.indirizzo_dl,this.selected.azienda.indirizzo_numero_dl].join(' ') || [this.selected.azienda.indirizzo_tipo_via_dc,this.selected.azienda.indirizzo_dc,this.selected.azienda.indirizzo_numero_dc].join(' ')
        this.addebito_comune = this.selected.azienda.comune_dl || this.selected.azienda.comune_dc || ''
        this.addebito_cap = this.selected.azienda.cap_dl || this.selected.azienda.cap_dc || ''
        this.addebito_provincia = this.selected.azienda.provincia_dl || this.selected.azienda.provincia_dc || ''
      } else {
        this.sottoscritto = false
        this.addebito_nome = ''
        this.addebito_cognome = ''
        this.addebito_codice_fiscale = ''
        this.addebito_partita_iva = ''
        this.addebito_indirizzo = ''
        this.addebito_comune = ''
        this.addebito_cap = ''
        this.addebito_provincia = ''
      }
    },
    splitIban() {
      this.addebito_iban = {
        "paese": this.addebito_full_iban.substr(0, 2),
        "cin_eu": this.addebito_full_iban.substr(2, 2),
        "cin_it": this.addebito_full_iban.substr(4, 1),
        "abi": this.addebito_full_iban.substr(5, 5),
        "cab": this.addebito_full_iban.substr(10, 5),
        "conto": this.addebito_full_iban.substr(15)
      }
    },
  },
  watch: {
    addebito_full_iban (val) {
      if (this.metodo_pagamento && this.metodo_pagamento['nome'] == 'Addebito in c/c') {
        var IBAN = require('iban');
        if (IBAN.isValid(val)) {
          this.addebito_full_iban = this.addebito_full_iban.replace(" ","")
          this.splitIban()
          this.getEstremiBanca()
        }
        if (!val) {
          this.addebito_iban = {}
        }
      }
    },
    radio_ca (val) {
      if (val == 'false') {
        this.appendice_data = null
      }
    },
    privacy_b1 (val) {
      if (val) this.err_trattamento_dati = ''
    }
  },
  mounted() {
    if (this.selected.azienda && this.selected.azienda['id_crm']) {
      if (this.selected.id) {
        if (this.selected.addebito_iban) {
          this.addebito_full_iban = this.selected.addebito_iban
          // this.addebito_iban = this.selected.addebito_iban
          this.splitIban()
        } else {
          this.getBanche()
        }
      }
    }
    this.getStati()
    this.getMetodiPagamento()
    this.getUffici()
    this.getProvince()
    if (this.selected.azienda) {
      this.privacy_b1 = this.selected.azienda.privacy_b1
      this.privacy_b2 = this.selected.azienda.privacy_b2
      this.privacy_b3 = this.selected.azienda.privacy_b3
      this.privacy_b4 = this.selected.azienda.privacy_b4
      this.privacy_b5 = this.selected.azienda.privacy_b5
    }
    // adding first tab "antiricclaggio" for later checks
    if (this.selected && this.selected.voci_preventivo && this.selected.voci_preventivo.length > 0) {
      if (!this.tab_aggiunte.includes('antiriciclaggio')) {
        const firstTariffa = this.selected.voci_preventivo[0].tariffa_applicata;
        if (firstTariffa.servizio.codice === 'Contabilita') {
          this.tab_aggiunte.push('antiriciclaggio');
        }
      }
    }
    // if (!this.tab_aggiunte.find( el => el === 'antiriciclaggio') &&
    //     this.selected.voci_preventivo[0].tariffa_applicata.servizio.codice === 'Contabilita') this.tab_aggiunte.push('antiriciclaggio')
    if (this.selected.id) {
      Object.keys(this.selected).forEach(e => this[e] = !this.selected[e] ? "" : this.selected[e])
      // console.log("Contratto --> ",this.antiric_titolare);
      if (this.antiric_soci == "") {
        this.antiric_titolare = {}
        this.antiric_soci = []
      }
      // this.codice_ufficio['label'] = this.selected.codice_ufficio
      // this.selected.codice_ufficio['codice'] = this.selected.codice_ufficio

// MAP LISTA TEMPLATES a lista di ID poi cerca se ID del template presente in mapped array e se non presente inserisci

      if (this.selected.voci_preventivo) {
        this.selected.voci_preventivo.forEach( v => {
          v.tariffa_applicata.templates.forEach( t => {
            let selT = this.selected.templates.find( sel_t => sel_t.nuovo_nome == t.template_stampa.nuovo_nome)
            t['attivo'] = selT ? selT.attivo : false

            let control = this.lista_templates.find( tmp => {
              if (tmp.id_template_stampa == t.id_template_stampa) return tmp
            })
            if (!control) this.lista_templates.push(t)
          })
          // aggiunge anche elementi nulli, poichè lo fa per ogni tariffa_applicata
          if (v.tariffa_applicata.tab_contratto) {
            this.tab_aggiunte.push(v.tariffa_applicata.tab_contratto)
          }
        })
      }

      if ( (this.selected.azienda && this.selected.azienda.tipo_azienda == 'DITTA IND.') ||
        (this.selected.azienda
        && this.selected.azienda.contatti.length
        && this.selected.azienda.contatti.find(c => c.id_ruolo == 93 || c.id_ruolo == 1).contatto.codice_fiscale == this.selected.addebito_codice_fiscale) ) {
        this.sottoscritto = true
      }
      // this.selected.templates.forEach(t => {
      //   this.lista_templates.push(t)
      // })

      if (this.selected.appendice_data) {
        this.radio_ca = 'true'
      } else {
        this.radio_ca = 'false'
      }
      if (this.tab_aggiunte.find( el => el === 'antiriciclaggio') && this.selected.azienda) {
        // console.log(!this.selected.antiric_soci ? 'yes' : 'no',this.selected.azienda)
        // if (this.selected.azienda.tipo_azienda == 'DITTA IND.') {
        //   this.antiric_titolare = {}
        //   this.antiric_titolare['nome'] = this.selected.azienda.ind_nome
        //   this.antiric_titolare['cognome'] = this.selected.azienda.ind_cognome
        //   // this.antiric_titolare['nome'] = this.selected.azienda.ragione_sociale.split(" ")[1]
        //   // this.antiric_titolare['cognome'] = this.selected.azienda.ragione_sociale.split(" ")[0]
        // } else if (!this.selected.antiric_soci || !this.selected.antiric_soci.length) {
        // if (!this.selected.antiric_soci || !this.selected.antiric_soci.length) {
        //   let tit = this.selected.azienda.contatti.find( c => c.id_ruolo == 1)
        //   let rap_legal = this.selected.azienda.contatti.find( c => c.id_ruolo == 93)
        //   // console.log("no soci => ",tit,rap_legal);
        //   this.antiric_titolare = {}
        //   this.antiric_titolare['nome'] = tit ? tit.contatto.nome : rap_legal.contatto.nome
        //   this.antiric_titolare['cognome'] = tit ? tit.contatto.cognome : rap_legal.contatto.cognome
        //   this.antiric_soci = []
        // } else {
          let l = this.selected.antiric_soci.length
          // console.log("ID + antiric_soci => ",l,this.antiric_titolare);
          if (l>0){
            this.antiric_titolare = this.selected.antiric_soci[l-1]
            this.antiric_soci = this.selected.antiric_soci.slice(0,l-1)
          }
        // }
      }
    } else {
      if (this.selected) {
        if (this.selected.voci_preventivo) {
          this.selected.voci_preventivo.forEach( v => {
            v.tariffa_applicata.templates.forEach( t => {
              let control = this.lista_templates.find( tmp => {
                if (tmp.id_template_stampa == t.id_template_stampa) return tmp
              })
              if (!control) this.lista_templates.push(t)
            })
            // aggiunge anche elementi nulli, poichè lo fa per ogni tariffa_applicata
            if (v.tariffa_applicata.tab_contratto) {
              this.tab_aggiunte.push(v.tariffa_applicata.tab_contratto)
            }
          })
        }
        this.note = this.selected.note_preventivo

        // console.log(this.selected, 'contrattoooooo',this.tab_aggiunte);
        if (this.tab_aggiunte.find( el => el === 'antiriciclaggio') && this.selected.azienda) {
          if (this.selected.azienda.tipo_azienda == 'DITTA IND.') {
            this.antiric_titolare['nome'] = this.selected.azienda.ind_nome
            this.antiric_titolare['cognome'] = this.selected.azienda.ind_cognome
          } else {
            // console.log(' TITOLARE && SOCI: ',this.selected.azienda.contatti);
            let tit = this.selected.azienda.contatti.find( c => c.id_ruolo == 1)
            let rap_legal = this.selected.azienda.contatti.find( c => c.id_ruolo == 93)
            // console.log(' TITOLARE && SOCI: ',tit,rap_legal);
            if (tit || rap_legal) {
              this.antiric_titolare['nome'] = tit ? tit.contatto.nome : rap_legal.contatto.nome
              this.antiric_titolare['cognome'] = tit ? tit.contatto.cognome : rap_legal.contatto.cognome
              this.antiric_titolare['comune_nascita'] = tit ? tit.contatto.comune_nascita : rap_legal.contatto.comune_nascita
              this.antiric_titolare['data_nascita'] = tit ? tit.contatto.data_nascita : rap_legal.contatto.data_nascita
            }
          }
          // console.log(this.antiric_titolare);
        }
        // this.metodo_pagamento = ""

        this.data_decorrenza =  new Date()
        this.data_decorrenza.setDate((this.data_decorrenza.getDate() + 30))
      }
    }
    if (!this.lista_templates.find( t => {
      t.nuovo_nome == 'scheda_cliente.docx'
    })) this.lista_templates.unshift({ nome: 'Scheda cliente',
                        nuovo_nome: 'scheda_cliente.docx',
                        posizione: 0,
                        id: null,
                        attivo: false })
    if (!this.lista_templates.find( t => {
      t.nuovo_nome == 'privacy.docx'
    })) this.lista_templates.unshift({ nome: 'Informativa privacy',
                        nuovo_nome: 'privacy.docx',
                        posizione: 1,
                        id: null,
                        attivo: false })
    // this.tab_aggiunte.push('appendice')
    this.tab_aggiunte.push('privacy')
    this.tab_aggiunte.push('dettagli')
    // console.log(this.antiric_titolare);
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent,
    'v-select': vSelect,
  },
}
</script>
